<template>
  <div>
    <div v-if="showloading">

      <loader-appie/>

    </div>
    <div v-else>

      <log-in-header @toggleSidebar="toggleSidebar"/>


      <div class="container">
        <testimonial-login :sliderContents="localSliderContents"/>
        <div class="logincard ">

          <form @submit.prevent="submitForm">
            <div class="row">
              <div class="col-12  mx-auto">
                <label for="mobile">Mobile Number</label>
                <b-form-input
                    id="mobileNumber"
                    v-model="mobileno"
                    type="number"
                    @input="validateMobileNumber"
                    :formatter="formatterFunction"
                    placeholder="Mobile Number"
                    oninput="this.value = this.value.replace(/^0/, '');this.value = this.value.replace(/^[^6-9][0-9]*/, '');"
                    required
                    ref="mobileInput"
                ></b-form-input>
                <span v-if="isMobileErrorMsg" style="color: red;">Enter a valid 10-digit mobile number</span>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-6 mx-auto">
                <div class="pricing-btn mt-3 text-center">
                  <b-button pill variant="warning" type="submit" :disabled="!isMobileValid"><b>Send OTP</b></b-button>
                </div>
              </div>
            </div>

          </form>


          <div class="col-12 mx-auto">
            <div class="pricing-btn mt-3 text-center">
              <span>By Continuing you agree to </span> <br>
              <span><a href="https://nithrajobs.com/tc_employer_posting.php" style="color: blue !important;">Terms and Conditions</a></span> & <span><a href="https://www.nithra.mobi/privacy.php" style="color: blue !important;">Privacy Policy</a></span>

            </div>

          </div>
        </div>

      </div>
      <br>

      <div class="back-to-top">
        <a href="#"><i class="fal fa-arrow-up"></i></a>
      </div>
      <!--====== APPIE BACK TO TOP PART ENDS ======-->
      <!--Modal Start-->
      <div>

        <b-modal id="my-modal" ref="myModal" class="centered-modal" no-close-on-backdrop>
          <!--        <b-modal id="my-modal" @hide="onModalHide" ref="myModal">-->
          <span>கீழே உள்ள தொலைபேசி எண் சரி எனில் continue-வை கிளிக் செய்யவும். <br> தவறு எனில் Edit-கிளிக் செய்யவும்</span>
          <div class="row">
            <div class="col-12 col-md-6 mx-auto">
              <div class="pricing-btn mt-3 text-center">
                <span>{{ GetMobileNumber }}  </span>
                <b-button pill variant="warning" @click="mobileNumberEditButton" style="margin:  5px"><i class="fa fa-pencil"
                                                                                    aria-hidden="true"></i> Edit
                </b-button>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-6 mx-auto">
              <div class="pricing-btn mt-3 text-center">
                <b-button variant="primary" @click="OtpModal">Continue</b-button>
              </div>
            </div>
          </div>


        </b-modal>
      </div>
      <!--Modal Start End-->

      <!--Otp Modal Start-->
      <div>

        <b-modal id="modal-center" ref="myModal1" centered title="BootstrapVue" no-close-on-backdrop>
          <!--          <p class="my-4">Vertically centered modal!</p>-->

          <b-card
              class="py-8 px-6 text-center mx-auto ma-4"
              bg-variant="light"
              text-variant="dark"
              border-variant="secondary"
              shadow="lg"
              max-w="400"
              w="100%"
          >
            <h3 class="text-h6 mb-4">Enter Verification Code</h3>

            <div class="text-body-2">
              Enter 6 digit otp number sent to your mobile number
            </div>
            {{ GetMobileNumber }}

            <b-card no-body class="my-4" bg-variant="surface" text-variant="dark">
              <b-form-input
                  v-model="otp"
                  type="number"
                  @input="validateotp"
                  :formatter="formatterotp"
                  placeholder="Enter verification code"
                  variant="outline"
                  required
              ></b-form-input>

            </b-card>
            <span v-if="isinavalidotp" style="color: red;">The OTP you have entered is invalid</span>

            <span v-if="isOtpErrorMsg" style="color: red;">Enter a 6-digit Otp</span><br>

            <p v-if="timeRemaining > 0">Resend OTP in <span style="color: red">{{ formatTime(timeRemaining) }}</span></p>



            <!--            <div class="row" v-if="timeRemaining > 0">-->
            <div class="row">
              <div class="col-12 col-md-6 mx-auto">
                <div class="pricing-btn mt-3 text-center">

                  <b-button pill variant="warning" type="submit" @click="VerifyOtp" :disabled="!isOtpValid"><b>Verify OTP</b></b-button>

                  <!--                  <b-button pill variant="warning" type="submit" @click="VerifyOtp" :disabled="!isMobileValid"><b>Verify-->
                  <!--                    OTP</b></b-button>-->

                </div>
              </div>
            </div>
            <!--            <div class="text-caption" v-else>-->
            <div class="text-caption"  v-if="timeRemaining <= 0">
              Didn't receive the code? <a href="#"  style="color: blue !important;" @click="ResendOtp">Resend</a>
            </div>
          </b-card>
        </b-modal>
      </div>
      <!--Otp Modal End-->
    </div>
  </div>

</template>

<script>

import testmonialAvater from "@/assets/images/testimonial-user.png"
import traffic_thumb from '@/assets/images/traffic-thumb.png'

import LogInHeader from './LogInHeader.vue'

import TestimonialLogin from './TestimonialLogin.vue'

import LoaderAppie from '../LoaderAppie.vue'
import {callAxios} from '@/main.js';
import CryptoJS from "crypto-js";


export default {
  name: 'LogIn',
  components: {
    LogInHeader,
    // SidebarHomeOne, HeroHomeOne, ServicesHomeOne, FeaturesHomeOne, TrafficHomeOne, TestimonialHomeOne, TeamHomeOne,
    // PriceingHomeOne, FaqHomeOne, BlogHomeOne, ProjectHomeOne, FooterHomeOne,
    TestimonialLogin,
    LoaderAppie,
  },
  data() {
    return {
      timeRemaining: 60, // Time in seconds
      timerInterval: null,
      otp: '',

      mobileno : '',
      GetMobileNumber : '',
      isMobileValid: false,
      isMobileErrorMsg:true,
      isOtpErrorMsg:true,
      isinavalidotp:false,

      isOtpValid:false,

      traffic_thumb:traffic_thumb,
      testmonialAvater:testmonialAvater,
      sidebar:false,
      showloading:true,


      localSliderContents: [],
      loadingImage: [],
      splash_screen: [],

    }
  },
  async created() {
    this.preLoading();
    document.addEventListener('scroll', this.topToBottom)

    try {
      const demoDatas = await callAxios('https://jobspro.nithrajobs.com/api/auth/slider', '', 'post');
      // console.log(demoDatas);
      this.loadingImage = demoDatas;
      this.splash_screen = demoDatas.splash_screen;
      console.log(this.splash_screen)
      this.localSliderContents = demoDatas.slider || [];
      // console.log(this.localSliderContents)
      // Handle the data as needed
    } catch (error) {
      // Handle errors if needed
      console.error('Error in created hook:', error);
    }

  },


  methods: {
    encryptUrl(url) {
      const ciphertext = CryptoJS.AES.encrypt(url, 'secret key 123').toString();
      return ciphertext;
    },
    decryptUrl(ciphertext) {
      const bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
      const originalUrl = bytes.toString(CryptoJS.enc.Utf8);
      return originalUrl;
    },

    async OtpModal() {


      try {
        this.$refs.myModal.hide();
        this.$refs.myModal1.show();
        this.timeRemaining = 60;

        const otpdata = await callAxios('https://jobspro.nithrajobs.com/api/auth/register', {
          phonenumber: this.mobileno
        }, 'post');

        console.log(otpdata);

        this.clearTimer(); // Clear existing interval
        this.startTimer();
      } catch (error) {
        console.error('Error in Axios request:', error);
        // Handle the error as needed, e.g., show an error message to the user
      }
    },
    showToast() {
      // alert('yes');
      this.isinavalidotp = true;
      // Hide the toast after a certain duration
      setTimeout(() => {
        this.isinavalidotp = false;
      }, 3000); // Adjust the duration as needed
    },
    async VerifyOtp() {
      try {
        const otpdata = await callAxios('https://jobspro.nithrajobs.com/api/auth/login', {
          phonenumber: this.mobileno,
          otp: this.otp
        }, 'post');
        // console.log('otpdata',otpdata.status);
        if(otpdata.status == false){
          // alert(otpdata.message);
          this.showToast() ;
          // alert('error');
        }
        else {


          localStorage.setItem('token', otpdata.token);
          // localStorage.getItem('token')
          const inputString = otpdata.activity;
          const lastPart = inputString.split('.').pop();
          const url = otpdata.url;
//         const crypto = require('crypto');
//
// // Your secret key (keep this secret)
//         const secretKey = 'YourSecretKeyHere';
//         const encryptedUrl = this.encryptApiUrl(apiurl);
//         // this.urlData = url;
//         console.log(lastPart);
          // alert(lastPart);
          // eslint-disable-next-line no-empty
          if (lastPart === 'Employer_Dynamic_Home_Activity') {
            const encryptedString = this.encryptUrl(url);
            await this.$router.push(`/home-page?page=${encodeURIComponent(encryptedString)}`);
            localStorage.setItem('homeurl', otpdata.url);
          } else if (lastPart === 'Employer_Company_Register') {
            const encryptedString = this.encryptUrl(url);
            await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
          }
        }

      } catch (error) {
        console.error('Error in Axios request:', error);
      }
    },

//      encryptApiUrl(apiurl) {
//   const cipher = crypto.createCipher('aes-256-cbc', secretKey);
//   let encryptedApiUrl = cipher.update(apiurl, 'utf-8', 'hex');
//   encryptedApiUrl += cipher.final('hex');
//   return encryptedApiUrl;
// },

    mobileNumberEditButton() {
      // alert('krishna')
      this.$refs.myModal.hide();
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.mobileInput.focus();
        });
      }, 1000);

    },
    formatterFunction(e) {
      return String(e).substring(0, 10);
    },
    formatterotp(e) {
      return String(e).substring(0, 6);
    },

    validateMobileNumber() {
      this.mobileno = this.mobileno.replace(/\D/g, "");
      if (this.mobileno.length > 10) {
        // alert(('krishna'))
        this.mobileno = this.mobileno.slice(0, 10);
      }

      // Check if the input is a valid 10-digit number
      this.isMobileValid = /^\d{10}$/.test(this.mobileno);
      if(this.isMobileValid){
        this.isMobileErrorMsg=false;
      }
      else{
        this.isMobileErrorMsg=true;
      }
    },
    validateotp() {
      this.isOtpValid = /^\d{6}$/.test(this.otp);
      if(this.isOtpValid){
        this.isOtpErrorMsg=false;
      }
      else{
        this.isOtpErrorMsg=true;
      }
    },
    // onModalHide() {
    //   // This method is called when the modal is hidden
    //   console.log('Modal hidden');
    // },

    closeModal() {
      // Programmatic way to close the modal
      this.$refs.myModal.hide();
    },

    submitForm() {
      if (this.isMobileValid) {
        this.$refs.myModal.show(); // Show the modal if mobile number is valid
        this.GetMobileNumber = this.mobileno;
      } else {
        console.log('Mobile number is not valid. Form not submitted.');
      }
      // console.log('Form submitted successfully');
    },


    preLoading() {
      setTimeout(() => {
        this.showloading = false
      }, 2000)
    },
    topToBottom() {
      const result = document.querySelector('.back-to-top')
      if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
        result.style.display = "block";
      } else {
        result.style.display = "none";
      }
    },
    toggleSidebar() {
      this.sidebar = !this.sidebar
    },

    async ResendOtp() {
      this.otp='';
      this.validateotp();
      const otpdata = await callAxios('https://jobspro.nithrajobs.com/api/auth/register', {
        phonenumber: this.mobileno
      }, 'post');
      console.log(otpdata)
      this.timeRemaining = 60;
      this.clearTimer(); // Clear existing interval
      this.startTimer()
    },

    startTimer() {
      // Update the timer every second
      this.timerInterval = setInterval(() => {
        if (this.timeRemaining > 0) {
          this.timeRemaining--;
        } else {
          this.clearTimer();
        }
      }, 1000);
    },

    clearTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },

    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    },
  },

  // mounted() {
  //   this.timeRemaining = 5;
  //   this.startTimer();
  // },

}
</script>

<style>

.dashed-line-container {
  display: flex;
  align-items: center;
}

.dashed-line {
  flex: 1; /* Allow the dashed line to take up remaining space */
  border-top: 1px dashed #333; /* Dashed border color and style */
  margin: 0 10px; /* Add margin for spacing between dashes and text */
}

.text-inside {
  white-space: nowrap; /* Prevent the text from breaking to a new line */
  padding: 0 10px; /* Add padding for spacing between dashes and text */
}

.modal-header {
  display: none !important;
}

.modal-footer {
  display: none !important;
}

.centered-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.logincard {
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
  padding: 20px 10px 10px 10px;
  width: 50%;
  margin: auto;
}

</style>
